
import { defineComponent, reactive, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ImportacaoRegistrosExcelModal from '@/views/Cadastros/Produtos/ImportacaoRegistrosExcelModal.vue';
import storeSistema from '@/store/storeSistema';
import ServicoTipoProducao from '@/servicos/Cadastros/PCP/ServicoTipoProducao';
import TipoProducaoModal from './TipoProducaoModal.vue';

export default defineComponent({
  name: 'TipoProducao',
  components: {
    TelaPadraoCrud,
    TipoProducaoModal,
    ImportacaoRegistrosExcelModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoTipoProducao = new ServicoTipoProducao();
    const refCrudTipoProducao = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da etapa de produção:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Identificador', dataIndex: 'codigo', key: 'Identificador', position: 0, visible: false, ordering: false,
      },
      {
        title: 'Descrição', dataIndex: 'nome', key: 'Nome', position: 1, visible: true, ordering: true, fixed: 'left', ellipsis: true, width: 400, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'Ativo', position: 3, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 80,
      },
      {
        title: 'Ações', key: 'acoes', position: 4, visible: true, fixed: 'right', width: 120, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'IdentificadorProduto', ordem: 'DESC' } as IOrdenacao);

    const state = reactive({
      exibirImportacaoExcel: false,
    });

    function abrirImportacaoRegistros() {
      state.exibirImportacaoExcel = true;
    }

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrudTipoProducao.value !== undefined) {
        await refCrudTipoProducao.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }
    return {
      state,
      storeSistema,
      crudBase,
      servicoTipoProducao,
      refCrudTipoProducao,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      abrirImportacaoRegistros,
    };
  },
});
